<div>
  <!-- Page Header -->
  <div class="mb-6">
    <h1 class="text-heading-xl mb-2">{{ 'projectOwners.title' | translate }}</h1>
    <p class="text-body-md text-secondary">{{ 'projectOwners.subtitle' | translate }}</p>
  </div>

  <!-- Project Owners Table -->
  <p-table
    #table
    [scrollable]="true"
    scrollHeight="flex"
    [value]="projectOwners()"
    [loading]="loading()"
    [paginator]="true"
    [lazy]="true"
    [rows]="queryParams().limit"
    [totalRecords]="totalRecords()"
    [first]="first"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    currentPageReportTemplate="{first}-{last} of {totalRecords}"
    [stripedRows]="true"
    (onPage)="onPageChange($event)"
  >
    <!-- Table Caption with Search and Add Button -->
    <ng-template pTemplate="caption">
      <div class="flex flex-col md:flex-row gap-3 md:gap-2">
        <div class="flex gap-2">
          <p-button
            label="{{ 'projectOwners.addProjectOwner' | translate }}"
            icon="pi pi-plus"
            severity="success"
            [disabled]="loading()"
            (onClick)="addProjectOwner()"
          >
          </p-button>
        </div>
        <p-iconfield iconPosition="left" class="md:ml-auto w-full md:w-auto">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          <input
            #searchInput
            pInputText
            type="text"
            [formControl]="searchControl"
            [disabled]="loading()"
            [placeholder]="'projectOwners.searchPlaceholder' | translate"
            class="w-full"
          />
        </p-iconfield>
      </div>
    </ng-template>

    <!-- Table Header -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="fullName" style="min-width: 200px">
          {{ 'projectOwners.fullName' | translate }}
          <p-sortIcon field="fullName"></p-sortIcon>
        </th>
        <th pSortableColumn="email" style="min-width: 250px">
          {{ 'projectOwners.email' | translate }}
          <p-sortIcon field="email"></p-sortIcon>
        </th>
        <th style="min-width: 120px">{{ 'projectOwners.projects' | translate }}</th>
        <th pSortableColumn="createdAt" style="min-width: 200px">
          {{ 'projectOwners.createdAt' | translate }}
          <p-sortIcon field="createdAt"></p-sortIcon>
        </th>
        <th style="min-width: 150px">{{ 'projectOwners.actions' | translate }}</th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-projectOwner>
      <tr>
        <td style="min-width: 200px">{{ projectOwner.fullName }}</td>
        <td style="min-width: 250px">{{ projectOwner.email }}</td>
        <td style="min-width: 120px">{{ projectOwner.projectCount }}</td>
        <td style="min-width: 200px">{{ projectOwner.createdAt | date : 'medium' }}</td>
        <td style="min-width: 150px">
          <div class="flex gap-2">
            <p-button
              icon="pi pi-pencil"
              [rounded]="true"
              size="small"
              [ariaLabel]="'projectOwners.edit' | translate"
              (onClick)="editProjectOwner(projectOwner)"
            >
            </p-button>
            <p-button
              icon="pi pi-trash"
              [rounded]="true"
              size="small"
              [ariaLabel]="'projectOwners.delete' | translate"
              (onClick)="deleteProjectOwner(projectOwner)"
            >
            </p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- Empty state -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center py-8">
          <div class="flex flex-col items-center gap-3">
            <i class="pi pi-users text-4xl text-muted"></i>
            <p class="text-body-md text-muted">{{ 'projectOwners.noData' | translate }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Confirmation Dialog -->
  <p-confirmDialog></p-confirmDialog>

  <!-- Toast Messages -->
  <p-toast></p-toast>
</div>
